import { z } from 'zod';
import { GameSchema } from 'types/games';
export var GameStoreStateSchema = z.object({
    games: z.record(GameSchema)
});
